import React, { useState } from 'react'
import { Box, Grid, Theme, Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { CreateRequestModal } from './create-request'
import { N1RequestMy, User } from '../../../types/default-types'

export const Request: React.FC<{ data?: N1RequestMy; updateInfo(): void; className: any }> = ({
  data,
  updateInfo,
  className,
}): JSX.Element => {
  const classes = useStyles()

  const [createRequestModal, setCreateRequestModal] = useState<boolean>(false)

  return (
    <Box className={classes.requestBox}>
      <CreateRequestModal
        updateInfo={updateInfo}
        show={createRequestModal}
        onClose={() => setCreateRequestModal(false)}
      />

      {(!data || data.status === 'REJECT') && (
        <Grid container wrap="nowrap" justifyContent="center">
          <Grid item>
            <Box pb={4}>
              <Button
                variant="contained"
                color="secondary"
                className={classes.btn}
                onClick={() => setCreateRequestModal(true)}
              >
                Подать заявку
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
      {data && (
        <Box className={classes.requestStatusBox}>
          <Box className={classes.status}>
            Заявка: <span>{data.statusName}</span>
          </Box>
          {data.status === 'REJECT' ? (
            <Box className={classes.statusReject}>Ваша заявка отклонена, но Вы можете подать заявку еще раз</Box>
          ) : (
            <>
              <Box className={classes.nomination}>
                Номинация: <span>«{data.nomination.name}»</span>
              </Box>
              {data.command.users.length > 1 && (
                <Box className={classes.commandsBox}>
                  <Box className={classes.commandsName}>
                    Ваша команда «{data.nomination.name}»:&nbsp;{data.command.name}
                  </Box>
                  {data.command.users.map((item: User) => {
                    return (
                      <Box className={classes.commandsUser}>
                        {item.lastName} {item.firstName} {item.middleName}
                      </Box>
                    )
                  })}
                </Box>
              )}
            </>
          )}
        </Box>
      )}
    </Box>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  requestBox: {
    marginTop: 30,
    marginBottom: 30,
    [down('md')]: {
      marginTop: 25,
      marginBottom: 25,
    },
    [down('sm')]: {
      marginTop: 20,
      marginBottom: 20,
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '12px 50px!important',
    minHeight: '35px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 35px!important',
      minHeight: '30px!important',
    },
  },
  requestStatusBox: {
    width: '100%',
    fontSize: 18,
    borderRadius: 10,
    padding: '40px 0',
    backgroundColor: '#222222',
    [down('md')]: {
      fontSize: 17,
      padding: '35px 0',
    },
    [down('sm')]: {
      fontSize: 15,
      padding: '30px 0',
    },
  },
  status: {
    marginLeft: 50,
    '& span': {
      color: palette.secondary.main,
    },
    [down('sm')]: {
      marginLeft: 40,
    },
  },
  nomination: {
    marginLeft: 50,
    marginTop: 10,
    '& span': {
      color: palette.secondary.main,
    },
    [down('sm')]: {
      marginLeft: 40,
    },
  },
  commandsBox: {
    marginTop: 30,
    marginLeft: 50,
    [down('sm')]: {
      marginLeft: 40,
    },
  },
  commandsName: {
    color: palette.text.primary,
    fontSize: 20,
    [down('md')]: {
      fontSize: 18,
    },
    [down('sm')]: {
      fontSize: 16,
    },
  },
  commandsUser: {
    marginTop: 10,
  },
  statusReject: {
    marginLeft: 50,
    marginRight: 50,
    marginTop: 10,
  },
}))
